export default "__VITE_ASSET__Wm9ErYLu__"